import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { VariantType } from "@upsquad/shared";
import type { PersistConfig } from "redux-persist";
import storage from "redux-persist/es/storage";
import { logOut } from "@/src/auth/store/auth-slice";

type ColorScheme = "light" | "dark";

interface GeneralState {
	colorScheme: ColorScheme;
	variant: VariantType;
}

const initialState: GeneralState = {
	colorScheme: "light",
	variant: "default",
};

export const generalSlice = createSlice({
	name: "general",
	initialState,
	reducers: {
		setColorScheme: (state, action: PayloadAction<ColorScheme>) => {
			state.colorScheme = action.payload;
		},
		setVariant: (state, action: PayloadAction<VariantType>) => {
			state.variant = action.payload;
		},
		toggleColorScheme: (state) => {
			state.colorScheme = state.colorScheme === "light" ? "dark" : "light";
		},
	},
	extraReducers: (builder) => {
		builder.addCase(logOut, (state) => {
			state.variant = "default";
		});
	},
});

export const generalPersistConfig: PersistConfig<GeneralState> = {
	key: generalSlice.name,
	storage,
	whitelist: ["colorScheme", "variant"],
};

export const { setColorScheme, setVariant, toggleColorScheme } = generalSlice.actions;
